import { FaceCapture } from './components';

export function TestAvatar(): React.JSX.Element {
  return <FaceCapture />;
}
